import { useTheme } from 'next-themes';
import { Toaster as Sonner, toast } from 'sonner';
import { useLocaleDirection } from '@/i18n/useLocaleDirection';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  // Sonner's `position` is a physical corner and is not derived from `dir`, so mirror it here.
  const dir = useLocaleDirection();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      position={dir === 'rtl' ? 'bottom-left' : 'bottom-right'}
      className='toaster group'
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export { Toaster, toast };
